import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { refreshAccessToken } from '../../../utilities/extensions'

export default function DashboardDocumentsHeader() {
  const navigate = useNavigate()
  const [canDownloadUF, setCanDownloadUF] = useState(true)
  const [downloadingPDF, setDownloadingPDF] = useState(false)

  useEffect(() => {
    const handleDownloadUF = async () => {
      try {
        const newUrlResponse = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerDocuments.taxDocument2021UF)}`, {
          headers: {
            'Authorization': customerData.accessToken
          }
        })
        const newUrlData = await newUrlResponse.json()
        if (newUrlData.response.error) {
          if (newUrlData.response.error === 'Failed To Authenticate Token.') {
            const refreshedToken = await refreshAccessToken()
            refreshedToken && refreshedToken.length > 0 ? await handleDownloadUF() : navigate('/', { state: { expired: true } })
          } else
            console.error(newUrlData.response.error)
        } else {
          const downloadResponse = await fetch(newUrlData.response.s3Url)
          if (!downloadResponse.ok)
            setCanDownloadUF(false)
        }
      } catch (error) {
        //setCanDownloadUF(false)
      }
    }

    if (customerData.customerDocuments.taxDocument2021UF)
      handleDownloadUF()
    else
      setCanDownloadUF(false)
  }, [])

  const handleDownloadPDF = async (pdfURL) => {
    setDownloadingPDF(true)

    const addForm8888Response = await fetch(`${apiURL}/api/addForms?customerId=${customerData.customerLeadData.leadContact.contactId}&linkURL=${pdfURL}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const blob = await addForm8888Response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url;
    a.download = customerData.customerDocuments.taxDocument2021.split('/').pop()
    document.body.appendChild(a)
    a.click()
    a.remove()

    setDownloadingPDF(false)
  }

  const handleDownloadNewPDF = () => {
    if (canDownloadUF) {
      if(customerData.customerLeadData.leadStage.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9') {
        const hasQRCode = customerData?.customerQRCodeData?.qrCodeURL
        const hasAdvanceFundingLabel = customerData?.customerShippoLabels?.some(label => label.labelType === 'Advance Funding' && label.trackingStatus !== 'DELIVERED')
    
        if (hasQRCode || hasAdvanceFundingLabel)
          navigate('/downloadDocument')
        else
          navigate('/readyCloud')
      } else
        navigate('/downloadDocument')
    } else
      handleDownloadPDF(customerData?.customerDocuments?.['taxDocument2021'])
  }  

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        {customerData.customerDocuments.taxDocument2020.length > 0 && (
          <>
            <p>Download your 2020 IRS Forms to be Completed, Signed, and Mailed</p>
            <button onClick={() => handleDownloadPDF(customerData.customerDocuments['taxDocument2021'])} className='w-full bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white p-4 rounded-md shadow-full'>Download 2020 Tax Documents</button>
          </>
        )}
        {customerData.customerDocuments.taxDocument2021.length > 0 && (
          <div className='w-full flex flex-col items-center gap-8'>
            <button 
              onClick={handleDownloadNewPDF}
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p className='text-2xl'>Print Your Documents</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <p className='font-bold text-lg text-center'>You must complete this step to receive your refund.</p>
            {customerData.customerLeadData.leadStage.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9' && (
              <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
                <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
                <iframe className='w-full aspect-video' src="https://www.loom.com/embed/d4ddfdbe9a91498f9a0e29ea891489b1?sid=780d976e-db15-4555-9a35-cf3313961b5e&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            )}
            {customerData.customerLeadData.leadStage.leadStageId === '2b66e571-c4b5-424e-a666-5b76e4e36a4c' && (
              <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
                <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
                <iframe className='w-full aspect-video' src="https://www.loom.com/embed/ad69d9fd28fb43e9ab73005544d9c521?sid=f0ac3f6a-9ca8-4a2a-b6f2-6b62f1392ea6&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            )}
            {customerData.customerLeadData.leadStage.leadStageId === '3d261241-5b93-49df-95e6-6e8bfbc75f71' && (
              <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
                <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
                <iframe className='w-full aspect-video' src="https://www.loom.com/embed/cc2a42089cb84175be640fb7aa448c30?sid=6e66beec-813a-4ab1-b219-61247d156420&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            )}
          </div>
        )}
        {downloadingPDF && (
          <div className='flex flex-row items-center justify-center gap-2'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
            <p>Downloading PDF...</p>
          </div>
        )}
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>Click <span onClick={() => navigate('/downloadDocument')} className='text-[#FF8C00] underline'>HERE</span> to print, sign, and ship your documents.</p>
      </div>
    </div>
  )
}